import React from 'react';
import bem from 'utils/bem';
import { useNavigate } from 'react-router';
import { observer } from 'mobx-react-lite';
import Icon from 'components/Icon';
import Model from '../../../model';

import './index.sass';

const { cnBlock } = bem('login-button');

const LoginButton = ({ className, mod = 'green' }) => {

    const { isAuthenticated } = Model.user;
    const { openLoginForm } = Model.modal;
    const navigate = useNavigate();

    const onClick = () => {
        if (isAuthenticated) {
            navigate('/profile');
        } else {
            openLoginForm({});
        }
    }

    return (
        <div className={ cnBlock(className, mod) } onClick={onClick}>
            <Icon name={ isAuthenticated ? 'user-circle' : 'sign-in' }/>
        </div>
    )
}

export default observer(LoginButton);
